import React, { useEffect, useState } from "react";
import Select from "react-select";
import { handleExportData } from "./DataTable";
import { useForm, Controller } from "react-hook-form";
import { useLocation } from "react-router-dom";
import "@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css";
import "react-calendar/dist/Calendar.css";
import { useSelector } from "react-redux";
import { selectRoleRights } from "../store/slices/roleRightsSlice";

const Listfilter = ({ toggleFormFillrter, setGlobalFilter, filterOption, title, isExport = false, data, setData = () => {} }) => {
  const [fillter, setFillter] = useState({ selectFillter: "", search: "" });
  const [selectFilter, setSelectFilter] = useState(null);
  const [roleRightsData, setRoleRightsData] = useState([]);

  const {
    register,
    handleSubmit,
    reset,
    control,
    setValue,
    formState: { errors },
    watch,
  } = useForm({});

  const location = useLocation();

  const rightsData = useSelector(selectRoleRights);
  useEffect(() => {
    if (rightsData?.length) {
      setRoleRightsData(rightsData);
      rightsData.forEach((right) => setValue(right, true));
    }
  }, [rightsData, setValue]);

  const pagePermissions = {
    "/userlist": ["user.add"],
    "/companymasterlist": ["company.add"],
    "/locationList": ["location.add"],
    "/companylist": ["companylocation.add"],
    "/vendorlist": ["vendor.add"],
    "/shiftlist": ["shift.add"],
    "/designationlist": ["designation.add"],
    "/checkpointlist": ["checkpoint.add"],
    "/roleList": ["role.add"],
    "/apkConfiguration": ["appconfig.add"],
    "/attendanceReports": ["attendance.export"],
    "/getfire": ["firealertreport.export"],
    "/getLockReports": ["gatelockreport.export"],
    "/getTrespassing": ["trespassingreport.export"],
    "/getpanicmode": ["panicmodereport.export"],
    "/getsalaryreport": ["salaryreport.export"],
  };
  const checkPermission = (roleRightsData, permission) => !roleRightsData?.includes(permission);
  const currentPath = location.pathname;
  const requiredPermissions = pagePermissions[currentPath] || [];

  useEffect(() => {
    if (title) {
      setSelectFilter(null);
      setFillter({ selectFillter: "", search: "" });
    }
  }, [title]);

  useEffect(() => {
    if (filterOption?.length > 0) {
      setSelectFilter(filterOption[0]);
      setFillter((prevState) => ({
        ...prevState,
        selectFillter: filterOption[0]?.value,
      }));
    }
  }, [filterOption]);

  return (
    <>
      <div className="mb-4 row gy-2 justify-content-start">
        <div className="col-xxl-2 col-md-3 col-6">
          {location.pathname !== "/apkConfiguration" ? (
            <Select
              onChange={(e) => {
                setSelectFilter(e);
                setFillter((prevState) => ({
                  ...prevState,
                  selectFillter: e?.value,
                }));
              }}
              value={selectFilter}
              options={filterOption}
              placeholder="All"
              components={{ IndicatorSeparator: () => null }}
              styles={{
                control: (base, state) => ({
                  ...base,
                  border: state.isFocused ? "1px solid #222e3c" : "1px solid #ced4da",
                  // This line disable the blue border
                  boxShadow: state.isFocused ? "1px solid #222e3c" : "1px solid #222e3c",
                  "&:hover": {
                    border: state.isFocused ? "1px solid #222e3c" : "1px solid #222e3c",
                  },
                }),
                menu: (provided, state) => ({
                  ...provided,
                  zIndex: 9999,
                }),
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 9999, 
                }),
              }}
            />
          ) : null}
        </div>
        <div className="col-xxl-2 col-md-3 col-6">
          {location.pathname !== "/apkConfiguration" ? (
            <input
              onChange={(e) => {
                setFillter((prevState) => ({
                  ...prevState,
                  search: e?.target?.value,
                }));
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  setGlobalFilter(fillter); 
                }
              }}
              value={fillter?.search}
              type="search"
              id="search"
              name="search"
              className="form-control py-2 fw-medium"
              placeholder="Enter keyword"
            />
          ) : null}
        </div>
        <div className="col-xxl-2 col-md-3 col-6 text-start mt-sm-2 mt-3 d-flex gap-2">
          {location.pathname !== "/apkConfiguration" ? (
            <>
              <button
                onClick={() => {
                  setGlobalFilter(fillter);
                }}
                className="btn btn-lg btn-primary px-3 h-100"
              >
                Search
              </button>

              <button
                onClick={() => {
                  setFillter({ selectFillter: "all", search: "" });
                  setGlobalFilter({ selectFillter: "", search: "" });
                  setSelectFilter(filterOption[0]);
                }}
                className="btn btn-lg btn-primary px-3 h-100 ms-sm-2 ms-0"
              >
                Clear
              </button>
            </>
          ) : null}
        </div>
        <div className="col-xxl-6 col-md-3 col-6 text-start mt-sm-2 mt-3">
          {!isExport ? (
            <button
              onClick={() => {
                toggleFormFillrter(true);
              }}
              className="btn btn-lg float-end btn-primary px-3 h-100"
              disabled={requiredPermissions.some((permission) => checkPermission(roleRightsData, permission))}
            >
              Add
            </button>
          ) : (
            <button
              onClick={() => {
                if (data?.length) handleExportData(data);
              }}
              className="btn btn-lg float-end btn-primary px-3 h-100"
              disabled={requiredPermissions.some((permission) => checkPermission(roleRightsData, permission))}
            >
              Export
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default Listfilter;
